<template>
  <span class="badge" :class="`v-${variant}`"><slot>{{ label }}</slot></span>
</template>

<script>
export default {
  name: 'StatusBadge',
  props: {
    label: { type: String, default: '' },
    // neutral | primary | success | warning | danger | info
    variant: { type: String, default: 'neutral' }
  }
}
</script>

<style scoped>
.badge {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
  border: 1px solid transparent;
}
.v-neutral { background: rgba(255, 255, 255, 0.08); color: var(--text-secondary); border-color: rgba(255, 255, 255, 0.14); }
.v-primary { background: rgba(var(--primary-rgb), 0.16); color: var(--gradient-2); border-color: rgba(var(--primary-rgb), 0.35); }
.v-success { background: rgba(74, 222, 128, 0.15); color: var(--success); border-color: rgba(74, 222, 128, 0.32); }
.v-warning { background: rgba(248, 191, 113, 0.15); color: var(--warning); border-color: rgba(248, 191, 113, 0.35); }
.v-danger { background: rgba(255, 107, 107, 0.16); color: var(--danger); border-color: rgba(255, 107, 107, 0.38); }
.v-info { background: rgba(34, 211, 238, 0.14); color: var(--info); border-color: rgba(34, 211, 238, 0.32); }
</style>
